import { queries } from '@/features/_lib/react-query'
import type { TExposedFacilityDTO } from '@doutorsim/shared/exposed/facilities'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

export function useFacilityMap(mode: 'staff' | 'company' | 'facility', companyId?: string) {
  const staffQuery = useQuery({
    ...queries.staffFacilities.list,
    enabled: mode === 'staff',
  })

  const companyQuery = useQuery({
    ...queries.companies.facilities(companyId ?? ''),
    enabled: (mode === 'company' || mode === 'facility') && !!companyId,
  })

  const data = mode === 'staff' ? staffQuery.data : companyQuery.data

  const facilityMap = useMemo(() => {
    if (!data) return null
    return new Map<TExposedFacilityDTO['id'], TExposedFacilityDTO>(data.map((f) => [f.id, f]))
  }, [data])

  return facilityMap
}
